import { render, staticRenderFns } from "./ReporteEmpresa.vue?vue&type=template&id=36d8d349&"
import script from "./ReporteEmpresa.vue?vue&type=script&lang=js&"
export * from "./ReporteEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports